import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import BACKEND_URL from "../../config";

class ReviewList extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      reviews: [],
      employees: []
    };
  }
  componentDidMount = () => {
    fetch(`${BACKEND_URL}/reviews`)
      .then(res => res.json())
      .then(reviews => {
        return this.setState({ reviews: reviews });
      });

    fetch(`${BACKEND_URL}/employees`)
      .then(res => res.json())
      .then(employees => {
        return this.setState({ employees: employees });
      });
  };

  getEmployeeFullNameById = (id) =>  {
    const employee = this.state.employees.find(employee => employee.id === id) || { first_name: '', last_name: ''};
    return `${employee.first_name} ${employee.last_name}`;
  }

  deleteReview = reviewId => {
    fetch(`${BACKEND_URL}/reviews/${reviewId}`, {
      method: "DELETE"
    })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then(data => {
        if (data) {
          this.setState({
            reviews: this.state.reviews.filter(
              reviews => reviews.id !== reviewId
            )
          });
        }
      })
      .catch(function(err) {
        console.log(err);
      });
  };
  render = () => {
    if (this.state.redirectAdmin) {
      return <Redirect to="/" />;
    }
    return (
      <main className="mw6 center">
        {this.state.reviews.map(review => (
          <article key={review.id}>
            <Link
              to={`/review-card/${review.id}`}
              className="link dt w-100 bb b--black-10 pb2 mt2 dim blue"
            >
              <div className="dtc v-top pl2">
                <h1 className="f6 f5-ns fw6 lh-title black mv0">
                  Review for {this.getEmployeeFullNameById(review.employee_id)} by {this.getEmployeeFullNameById(review.reviewer_id)}
                </h1>
                <h2 className="f6 fw4 mt2 mb0 black-60">
                  <ul className="list pl0 ml0 center mw5 ba b--light-silver br3">
                    <li className="ph3 pv2 bb b--light-silver">
                      Comments: {review.comments}
                    </li>
                    <li className="ph3 pv2 bb b--light-silver">
                      Wins: {review.wins}
                    </li>
                    <li className="ph3 pv2 bb b--light-silver">
                      Opportunities: {review.opportunities}
                    </li>
                  </ul>
                </h2>
                <dl className={review.requires_feedback ? "mt2 f6" : "dn"}>
                  <dd className="ml0">Requires feedback</dd>
                </dl>
              </div>
            </Link>
          </article>
        ))}
      </main>
    );
  };
}

export default ReviewList;



// WEBPACK FOOTER //
// ./src/components/review/ReviewList.js